import { useTheme } from "@mui/material/styles";
import Divider from "@mui/material/Divider";

import Back from "ui/base/Back";
import Page from "ui/Page";

import { useProfileDeposits } from "areas/account/fabric";
import DepositList from "areas/account/ui/DepositList";


export default function AccountDeposits() {
	const deposits = useProfileDeposits();
	const theme = useTheme();

	const style = {
		body: {
			mt: theme.spacing(2.5),
			gap: theme.spacing(3)
		}
	};

	return (
		<Page maxWidth="md">
			<Back to="/account" label="Account" />
			<Page.Header title="Deposit history" subtitle="Recently purchased" />
			<Divider flexItem />
			<Page.Body sx={style.body}>
				<DepositList data={deposits.list} page={deposits.pagination?.Page} count={deposits.pagination?.Pages} take={deposits.take} setPage={deposits.updatePage} loading={deposits.isLoading} />
			</Page.Body>
		</Page>
	);
}